import { EventDispatcher } from '../events/event_dispatcher'

export class ExtendableError extends Error {
  constructor (message, meta = {}) {
    super(message)
    this.name = this.constructor.name
    this.meta = meta

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor)
    } else {
      this.stack = (new Error(message)).stack
    }
  }

  showBanner (message) {
    EventDispatcher.dispatchShowErrorEvent(message)
  }
}



// WEBPACK FOOTER //
// ./src/js/errors/extendable_error.error.js